import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./ru.json";

/**
 * Ресурсы подключаются инлайном, без http-backend: лишний сетевой запрос в
 * Telegram WebView на плохой сети означает секунду пустого экрана.
 *
 * Язык один — русский. Бэкенд отдаёт готовые русские строки (`alert.title`,
 * `activity.title`, `legal.body`), переводов на стороне сервера нет, поэтому
 * английская локаль дала бы полурусский интерфейс. `ru.json` при этом заводится
 * с первого экрана (правило ТЗ №7): русских литералов в JSX быть не должно,
 * иначе добавление второго языка потом потребует переписывать компоненты.
 */
void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru } },
  lng: "ru",
  fallbackLng: "ru",
  // React экранирует сам, двойное экранирование ломает кавычки и тире.
  interpolation: { escapeValue: false },
});

export { i18n };
export type TranslationKeys = typeof ru;
